import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import Icon from "../../../Display/Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EditField = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    FieldComponent,
    fieldMeta,
    fieldProps,
    id,
    isSaving,
    label,
    onBlur,
    onCancelEdit,
    onChange,
    onSaveEdit,
    value,
    afterLabelContent = null
  } = _ref;
  const controlsClass = () => cn({
    'flex w-10': true,
    'opacity-50': isSaving
  });
  const labelWIthControls = () => /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex my-1 justify-between",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex-auto capitalize text-text-blue text-sm font-heavy-font tracking-normal leading-4",
          children: label
        }), fieldProps.required && /*#__PURE__*/_jsx("span", {
          className: "inline-block text-red text-sm ml-1 transform -translate-y-1 align-text-top",
          children: "*"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: controlsClass(),
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "Cross",
          className: "bg-red rounded-full p-1 box-border",
          onClick: onCancelEdit,
          id: `${id}-cancel-btn`,
          color: "white",
          ariaLabel: "Cancel",
          size: 18,
          disabled: isSaving
        }), /*#__PURE__*/_jsx(Icon, {
          icon: "Check",
          className: "bg-green rounded-full p-1 ml-1 box-border",
          onClick: onSaveEdit,
          id: `${id}-save-btn`,
          color: "white",
          ariaLabel: "Save",
          size: 18,
          disabled: isSaving
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: afterLabelContent
    })]
  });
  return /*#__PURE__*/_jsx(FieldComponent, {
    ref: ref,
    id: `${id}-field`,
    label: labelWIthControls(),
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    ...fieldProps,
    ...fieldMeta,
    omitLabelStyles: true,
    omitRequiredLabel: true
  });
});
EditField.propTypes = {
  afterLabelContent: PropTypes.node,
  FieldComponent: PropTypes.object.isRequired,
  fieldMeta: PropTypes.object.isRequired,
  fieldProps: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  isSaving: PropTypes.bool.isRequired,
  label: PropTypes.any.isRequired,
  onBlur: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSaveEdit: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired
};
EditField.displayName = 'EditField';
export default EditField;
//# sourceMappingURL=EditField.js.map